{
  "responseType": "code",
  "scope": "openid email",
  "redirect_path": "/",
  "version": "v1",
  "grant_type": "authorization_code"
}